"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FootnoteLink = _interopRequireDefault(require("../../Footnote/FootnoteLink"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectFootnoteLinkStyles = (_ref, footnoteLinks) => {
  let {
    footnoteLinkColor,
    footnoteLinkFontName,
    footnoteLinkFontWeight,
    footnoteLinkLineHeight,
    footnoteLinkFontSize
  } = _ref;
  // This is used to apply the proper line height when there is 4 or more footnote links
  const MAX_FOOTNOTE_LINKS_ALLOWED = 3;
  const lineHeight = footnoteLinks?.length > MAX_FOOTNOTE_LINKS_ALLOWED ? footnoteLinkFontSize * footnoteLinkLineHeight : undefined;
  return {
    color: footnoteLinkColor,
    fontName: footnoteLinkFontName,
    fontWeight: footnoteLinkFontWeight,
    lineHeight,
    fontSize: footnoteLinkFontSize
  };
};
const renderFootnoteLinks = (footnoteLinks, themeTokens, onClickFootnote) => footnoteLinks?.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FootnoteLink.default, {
  tokens: selectFootnoteLinkStyles(themeTokens, footnoteLinks),
  content: footnoteLinks,
  onClick: onClickFootnote
}) : null;
var _default = exports.default = renderFootnoteLinks;